import React from 'react';
import FigmaBadge from '../../../../Elements/FigmaBadge';
import { getRunOutcomeBadge } from '../../../../Helpers/invoiceAutomationRunHelper';

// The outcome of a run of automatic invoicing: green Succeeded, red Failed, blue Running.
export default function InvoiceAutomationRunOutcomeBadge({ outcome = '' }) {
  const badge = getRunOutcomeBadge(outcome);
  return (
    <FigmaBadge
      variant={badge.variant}
      label={badge.label}
    />
  );
}
